import React from "react";

const SocialLinkInstagram = () => {
  return (
    <a
      target="_blank"
      href="https://www.instagram.com/the.raindrop.company/"
      className="flex flex-row gap-4 items-center cursor-pointer dark:md:hover:bg-color-dark-background-secondary md:hover:bg-color-background-secondary md:hover:scale-95 transition-all p-6 rounded-lg justify-center"
    >
      <div className="bg-gradient-to-r from-red-400 via-purple-500 to-blue-300  bg-clip-text text-transparent">
        <i className="fa fa-instagram text-6xl text-clip" />
      </div>
      <div>
        <h1 className="font-bold text-xl">Follow us on Instagram</h1>
        <h1 className="text-color-dark-text-secondary">
          @the.raindrop.company
        </h1>
      </div>
    </a>
  );
};

export default SocialLinkInstagram;
